"use strict";

var React = require('react/addons'),
    DocumentTitle = require('react-document-title'),
    cx = require('classnames'),
    BS = require('react-bootstrap'),
    ReactRouter = require('react-router'),
    ContactBuilder = require('../../partials/builder/BuilderContactForm');

var ProjectContactBuilder = React.createClass({displayName: "ProjectContactBuilder",
    contextTypes: {
        router: React.PropTypes.func
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            data = props.model.toJSON({
                includeListingPocs: true
            });

        return (
            React.createElement("div", null, 
                React.createElement("div", {className: "row margin-bottom-20 half-gutter"}, 
                    React.createElement("div", {className: "col-xs-12"}, 
                        props.description ? props.description : (
                            React.createElement("p", null, 
                                "Below is information to contact the builder's representative. If you have" + ' ' + 
                                "technical questions, please click on the \"support\" button on the right side to" + ' ' + 
                                "contact Agent Shield, the technilogy provider."
                            )
                        ), 

                        React.createElement(BS.Panel, {className: "margin-bottom-10 panel-no-header", header: (React.createElement("h2", {className: "orange-text"}, "Builder Representative Contact Information:"))}, 
                            React.createElement("ul", {className: "list-divided"}, 
                                _.map(data.listingPocs, function(poc){
                                    return (
                                        React.createElement("li", {key: poc.id}, 
                                            React.createElement("div", {className: "row margin-bottom-5"}, 
                                                React.createElement("div", {className: "col-sm-3"}, "Name:"), 
                                                React.createElement("div", {className: "col-sm-9"}, poc.name)
                                            ), 
                                            React.createElement("div", {className: "row margin-bottom-5"}, 
                                                React.createElement("div", {className: "col-sm-3"}, "Phone Number:"), 
                                                React.createElement("div", {className: "col-sm-9"}, 
                                                    poc.phone
                                                )
                                            ), 
                                            React.createElement("div", {className: "row"}, 
                                                React.createElement("div", {className: "col-sm-3"}, "Email:"), 
                                                React.createElement("div", {className: "col-sm-9"}, poc.email)
                                            )
                                        )
                                    );
                                })
                            ), 
                            React.createElement("div", {className: "row margin-bottom-5"}, 
                                React.createElement("div", {className: "col-sm-3"}, "Commission Offered:"), 
                                React.createElement("div", {className: "col-sm-9"}, data.commissionOffered && data.commissionOffered, React.createElement("br", null))
                            ), 
                            React.createElement("div", {className: "row margin-bottom-5"}, 
                                React.createElement("div", {className: "col-sm-3"}, "Referral Fee:"), 
                                React.createElement("div", {className: "col-sm-9"}, data.outOfStateReferralOffered && data.outOfStateReferralOffered)
                            ), 
                            React.createElement("div", {className: "row margin-bottom-5"}, 
                                React.createElement("div", {className: "col-sm-3"}, "Registration Policy:"), 
                                React.createElement("div", {className: "col-sm-9"}, data.clientRegistrationPolicy)
                            )
                        ), 

                        React.createElement(ContactBuilder, {model: props.model})
                    )
                )
            )
        );
    }

});
module.exports = ProjectContactBuilder;
